import { Link } from "@/i18n/routing";
import { IconMenuLinkArrow } from "@repo/assets/images";
import { highlightSearchText } from "@repo/lib/helpers";
import { useTranslations } from "next-intl";
const SearchItems = ({
  items,
  onClick,
  searchTerm
}) => {
  const t = useTranslations("Common");
  // Group items by action type
  const groupedItems = items?.reduce((acc, item) => {
    const type = item.action.type === "pdp" ? t("Products") : item.action.type === "plp" ? t("Categories") : t("Other");
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(item);
    return acc;
  }, {});
  return <ul data-sentry-component="SearchItems" data-sentry-source-file="SearchItems.jsx">
      {Object.entries(groupedItems)?.map(([heading, groupedItems]) => <li key={heading}>
          <h4 className="font-heading text-miniSearch-heading rtl:font-arabic py-3 text-base font-medium">
            {heading}
          </h4>
          <div className="divide-miniSearch-border divide-y">
            {groupedItems.map(item => <Link key={item.id} href={`/${item.action.type?.toLowerCase() === "plp" ? "collections/" : ""}${item?.action.urlSlug}`} onClick={onClick} className="text-miniSearch-text hover:bg-miniSearch-activeBg group flex items-center px-2 py-3 text-sm font-medium">
                <span className="flex-1">
                  {highlightSearchText(item.name, searchTerm)}
                </span>
                <span className="ms-2 shrink-0">
                  <IconMenuLinkArrow className="text-miniSearch-icon me-2 -rotate-45 transition-transform group-hover:-translate-y-1 ltr:group-hover:translate-x-1 rtl:rotate-[-135deg] rtl:group-hover:-translate-x-1" />
                </span>
              </Link>)}
          </div>
        </li>)}
    </ul>;
};
export default SearchItems;